var _path, _path2, _path3, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4937 11.4938C20.5971 2.39053 35.4038 2.39145 44.5063 11.4938C53.6088 20.5962 53.6087 35.4027 44.5064 44.5059C35.4031 53.609 20.5962 53.6092 11.4936 44.5059C2.3913 35.4028 2.39027 20.5971 11.4937 11.4938ZM41.5065 14.4936C34.0607 7.04796 21.94 7.04725 14.4935 14.4936C7.04708 21.94 7.04769 34.0596 14.4936 41.5062C21.9393 48.9525 34.0598 48.9526 41.5064 41.5062M41.5065 14.4936C48.9521 21.9392 48.9522 34.0597 41.5064 41.5062L41.5065 14.4936Z",
    fill: "#E50914"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9276 31.896C28.8816 32.333 28.4765 32.6666 27.992 32.6666C27.5071 32.6666 27.1017 32.3325 27.0562 31.8951L25.677 18.6455C25.5479 17.4052 26.6248 16.3333 27.9998 16.3333C29.3759 16.3333 30.4531 17.4067 30.3224 18.6477L28.9276 31.896Z",
    fill: "#E50914",
    stroke: "#E50914"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 17.2408C27.2809 17.2408 26.7177 17.8038 26.7852 18.4552L27.3892 24.2823L27.9931 30.1093L28.6039 24.2828L29.2147 18.4564C29.283 17.8045 28.7197 17.2408 28 17.2408ZM24.5158 18.6499C24.3221 16.7815 25.9374 15.1667 28 15.1667C30.0641 15.1667 31.6799 16.7837 31.4839 18.6533L30.073 32.1119C29.9707 33.088 29.0697 33.8334 27.992 33.8334C26.9135 33.8334 26.0121 33.0868 25.9108 32.1099L24.5158 18.6499Z",
    fill: "#E50914"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.9998,
    cy: 39.6667,
    rx: 2.33333,
    ry: 2.33333,
    fill: "#E50914"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError2);
export default __webpack_public_path__ + "static/media/error2.1493473e5b246d1854fe3519a8c838d9.svg";
export { ForwardRef as ReactComponent };